import { Controller } from '@libs/ui/form'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { formatErrors } from '@spa/components/FormFields/helpers'
import type { FC } from 'react'
import type { Control, FieldErrors } from 'react-hook-form'

type Props = {
  disabled: boolean
  control: Control
  errors: FieldErrors
}
export const NoteField: FC<Props> = ({ disabled, control, errors }) => {
  const { t } = usePlanningFormTranslation()

  return (
    <Controller.TextArea
      name='note'
      errorMessage={formatErrors({
        inputName: 'note',
        errors
      })}
      label={t('restForm.notes')}
      control={control}
      disabled={disabled}
      placeholder={t('component.fieldTextArea.title')}
    />
  )
}
